/**
 * <strong>Purpose:</strong> <br><br>
 * Provides the ability to add and manage a drop down arrow on a widget.
 * It adds a property to the widget "arrowMode", which can be used to position
 * the arrow relative to the textContainerNode.  It also adds classes to the dom node
 * to provide means of positioning the drop down arrow within the widget.
 *
 * @module mw-form/mixins/property/ArrowModeMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"

], function (declare) {

    var SUPPORTED_MODES = ["auto", "inline", "block"];

    return declare(null, {

        /**
         * @property  {string} arrowMode  Supported Values: auto, inline, block
         * @instance
         */
        arrowMode: "auto",

        postCreate: function () {
            this.inherited(arguments);
            this.domNode.classList.add("mwArrowModeMixin");
        },

        /**
         * Set the class for the widget which defines whether the drop down arrow
         * character appears inline with the widget text, or separated in its own block
         * @param mode
         * @private
         */
        _setArrowModeAttr: function (/*String*/ mode) {
            if ((typeof mode !== "string") || (SUPPORTED_MODES.indexOf(mode) === -1)) {
                throw new Error("'arrowMode' property expects one of these values: " + SUPPORTED_MODES);
            }

            this.domNode.classList.add("mwArrowMode" + this._capitalize(mode));

            SUPPORTED_MODES.forEach(function (supportedMode) {
                if (supportedMode !== mode) {
                    this.domNode.classList.remove("mwArrowMode" + this._capitalize(supportedMode));
                }
            },this);

            this._set("arrowMode",mode);
        },

        _capitalize: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    });

});